import React, { useEffect, useContext, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import { Link } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { Card, CardBody, CardFooter } from "../../components/card/card";
import ConfirmationDlg from "../../components/ConfirmationDlg";

function Documents() {
  const [openDlg, setOpenDlg] = useState(false);
  const context = useContext(AppSettings);

  useEffect(() => {
    context.setAppContentFullHeight(true);
    context.setAppContentClass("p-0");
    context.setAppSidebarCollapsed(true);

    var lightbox;

    if (!lightbox) {
      lightbox = new PhotoSwipeLightbox({
        gallery: ".gallery-image-list",
        children: "a",
        pswpModule: () => import("photoswipe"),
      });
      lightbox.init();
    }

    return function cleanUp() {
      context.setAppContentFullHeight(false);
      context.setAppContentClass("");
      context.setAppSidebarCollapsed(false);

      if (lightbox) {
        lightbox.destroy();
        lightbox = null;
      }
    };

    // eslint-disable-next-line
  }, []);

  function closeDialog() {
    setOpenDlg(false);
  }

  return (
    <div className="d-block d-md-flex align-items-stretch h-100">
      <ConfirmationDlg
        open={openDlg}
        onClose={closeDialog}
        btnSubmitText={"Submit"}
        btnCancelText={"Cancel"}
      >
        <div className="form-group mb-3">
          <label>Title</label>
          <input type="text" className={"form-control"} />
        </div>
        <div className="form-group mb-3">
          <label>Description</label>
          <textarea type="text" className={"form-control"}>
            {" "}
          </textarea>
        </div>
        <div className="form-group">
          <label>File</label>
          <input type="file" className={"form-control"} />
        </div>
      </ConfirmationDlg>
      <div className="gallery-menu-container">
        <PerfectScrollbar className="h-100">
          <div className="gallery-menu">
            <div className="p-3 d-flex align-items-center">
              <Link
                to="/"
                className="btn btn-outline-default text-nowrap btn-sm px-3 rounded-pill"
              >
                <i className="fa fa-arrow-left me-1 ms-n1"></i> Back
              </Link>
            </div>
            <div className="gallery-menu-header">Main</div>
            <div className="gallery-menu-item">
              <a href="#/" className="gallery-menu-link">
                <i className="fa fa-fw fa-video me-1"></i> Video Tutorial
              </a>
            </div>
            <div className="gallery-menu-item">
              <a href="#/" className="gallery-menu-link active">
                <i className="fa fa-fw fa-file-pdf me-1"></i> Documents
              </a>
            </div>
            <div className="gallery-menu-item">
              <a href="/document/doc-chat" className="gallery-menu-link active">
                <i className="fa fa-fw fa-message me-1"></i> AI Chat
              </a>
            </div>
          </div>
        </PerfectScrollbar>
      </div>
      <div className="gallery-content-container">
        <PerfectScrollbar className="h-100">
          <Card className="h-100">
            <div className="messenger">
              <div className="messenger-content">
                <div className="messenger-content-header">
                  <div className="messenger-content-header-mobile-toggler">
                    <a
                      href="#/"
                      data-toggle="messenger-content"
                      className="me-2"
                    >
                      <i className="bi bi-chevron-left"></i>
                    </a>
                  </div>
                  <div className="messenger-content-header-media">
                    <div className="media bg-theme text-black text-opacity-75 rounded-pill fs-24px fw-bold">
                      <i className="bi bi-android2"></i>
                    </div>
                  </div>
                  <div className="messenger-content-header-info">
                    Document Chat
                  </div>
                  <div className="messenger-content-header-btn">
                    <a href="#/" className="btn btn-link">
                      <i className="bi bi-search"></i>
                    </a>
                    <span className="dropdown">
                      <a
                        href="#/"
                        className="btn btn-link"
                        data-bs-toggle="dropdown"
                      >
                        <i className="bi bi-three-dots"></i>
                      </a>
                      <div className="dropdown-menu fs-11px">
                        <a
                          href="#/"
                          className="dropdown-item d-flex align-items-center"
                        >
                          <i className="bi bi-pencil-square fs-14px my-n1 me-3 ms-n2"></i>{" "}
                          EDIT
                        </a>
                        <a
                          href="#/"
                          className="dropdown-item d-flex align-items-center"
                        >
                          <i className="bi bi-info-circle fs-14px my-n1 me-3 ms-n2"></i>{" "}
                          INFO
                        </a>
                        <a
                          href="#/"
                          className="dropdown-item d-flex align-items-center"
                        >
                          <i className="bi bi-bell-slash fs-14px my-n1 me-3 ms-n2"></i>{" "}
                          MUTE
                        </a>
                        <a
                          href="#/"
                          className="dropdown-item d-flex align-items-center"
                        >
                          <i className="bi bi-x-circle fs-14px my-n1 me-3 ms-n2"></i>{" "}
                          CLEAR CHAT HISTORY
                        </a>
                        <div className="dropdown-divider"></div>
                        <a
                          href="#/"
                          className="dropdown-item d-flex align-items-center text-danger"
                        >
                          <i className="bi bi-trash fs-14px my-n1 me-3 ms-n2"></i>{" "}
                          DELETE AND LEAVE
                        </a>
                      </div>
                    </span>
                  </div>
                </div>
                <div className="messenger-content-body">
                  <PerfectScrollbar className="h-100">
                    <div className="widget-chat">
                      <div className="widget-chat-date">YESTERDAY</div>
                      <div className="widget-chat-item reply">
                        <div className="widget-chat-content">
                          <div className="widget-chat-message last">Hi.</div>
                          <div className="widget-chat-status">2:22PM</div>
                        </div>
                      </div>
                      <div className="widget-chat-item">
                        <div className="widget-chat-media">
                          <img src="/assets/img/ai_face.png" alt="" />
                        </div>
                        <div className="widget-chat-content">
                          <div className="widget-chat-name">GINA AI</div>
                          <div className="widget-chat-message">
                            Hi, is there anything I can help you with!
                          </div>
                          <div className="widget-chat-status">2:25PM</div>
                        </div>
                      </div>
                      <div className="widget-chat-item reply">
                        <div className="widget-chat-content">
                          <div className="widget-chat-message last">
                            Nothing.
                          </div>
                          <div className="widget-chat-status">2:27PM</div>
                        </div>
                      </div>
                      <div className="widget-chat-item">
                        <div className="widget-chat-media">
                          <img src="/assets/img/ai_face.png" alt="" />
                        </div>
                        <div className="widget-chat-content">
                          <div className="widget-chat-name">GINA AI</div>
                          <div className="widget-chat-message">Okay</div>
                          <div className="widget-chat-status">4:30PM</div>
                        </div>
                      </div>
                    </div>
                  </PerfectScrollbar>
                </div>
                <div className="messenger-content-footer">
                  <div className="input-group input-group-lg position-relative">
                    <button
                      className="btn position-absolute start-0"
                      id="trigger"
                    >
                      <i className="far fa-face-smile"></i>
                    </button>
                    <input
                      type="text"
                      className="form-control rounded-start ps-45px"
                      id="input"
                      placeholder="Write a message..."
                    />
                    <button className="btn btn-outline-default" type="button">
                      <i className="fa fa-paper-plane text-muted"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </PerfectScrollbar>
      </div>
    </div>
  );
}

export default Documents;
